import { FileClient } from "clients/rest";

export type B100223ExcelRequest = Partial<{
  haisorouteNoFrom: string;
  haisorouteNoTo: string;
}>;

export const B100223GetExcel = (props: B100223ExcelRequest) => {
  return FileClient.get("b100223/get/excel", {
    params: props,
  });
};
